import { useEffect, useState } from "react";
import "../../assets/styles/register/regiterAdd.scss";
import NewInput from "../../components/simple/NewInput";
import arrowAddAccount from "../../assets/svg/arrow-white-add-account.svg";
import arrowDropdown from "../../assets/svg/arrow-dropdown.svg";
import CheckBox from "../../components/simple/CheckBox";
import useForceUpdate from "use-force-update";
import IconPlus from "../../assets/svg/icon-plus-add-account.svg";
import IconMini from "../../assets/svg/icon-mini-add-account.svg";
import TickIcon from "../../assets/svg/tickIcon.svg";
import IconStar from "../../assets/svg/star-add-account.svg";
import BuyBasket from "../../assets/svg/basketBuy.svg";
import { useDispatch, useSelector } from "react-redux";
import DemoIconAuth from "../../assets/svg/demo-icon.svg";
import { apiAddBusinesses } from "../../api/businessApi";
import { apiSetAlert } from "../../api/appApi";
import momentJalaali from "moment-jalaali";
import { Calendar } from "react-datepicker2";
import { useNavigate } from "react-router-dom";
import imgDatePicker from "../../assets/svg/date-picker.svg";
import { appReset, appSetSendingRequest } from "../../store/actions/appAction";
import { errorDispatcher, formatDate, formatNumber, formatPrice } from "../../helpers";
import { apiGetSubscriptions, apiSetSubscriptions } from "../../api/subsciptionApi";
import { apiGetCurrencies } from "../../api/currencyApi";
import Select from "react-select";
import cartBussines from "../../assets/svg/cartBussines.svg";
import axios from "../../axios/axios";
import iconLoading from "../../assets/svg/icon-loading.svg";
import { Cities, States } from "../../constants/ProvincesList";
import businessTypes from "assets/js/businessTypes";
import warehouseAccountingSystem from "assets/js/warehouseAccountingSystem";
import warehouseAnalyzeSystem from "assets/js/warehouseAnalyzeSystem";
import { Container } from "@mui/material";

export default function Business() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const forceUpdate = useForceUpdate();

    const currencies = useSelector((state) => state.currencyReducer.currencies);
    const subscriptions = useSelector((state) => state.subscriptionReducer.subscriptions);
    const sendingRequest = useSelector((state) => state).appReducer.sendingRequest;
    const business = useSelector((state) => state).businessReducer.business;
    const token = useSelector((state) => state.appReducer.token);

    const [state, setState] = useState(States[0]);
    const [city, setCity] = useState(Cities[0]);
    const [taxRateData, setTaxRateData] = useState(9);
    const [toggleDatePicker, setToggleDatePicker] = useState(false);
    const [startDate, setStartDate] = useState(momentJalaali());
    const [endDate, setEndDate] = useState(momentJalaali().add(1, "year"));
    const [stepOne, setStepOne] = useState(true);
    const [stepTwo, setStepTwo] = useState(false);
    const [stepThree, setStepThree] = useState(false);
    const [paymentGateway, setPaymentGateway] = useState({});
    const [subscriptionId, setSubscriptionId] = useState(null);
    const [toggleEconomicInformation, setToggleEconomicInformation] = useState(false);
    const [contacts, setContacts] = useState(false);
    //   const [subscriptions, setSubscriptions] = useState([]);
    const [multipleCurrency, setMultipleCurrency] = useState(false);
    const [haveWarehouse, setHaveWarehouse] = useState(false);

    const [inputFields, setInputFields] = useState({
        main: {
            currencyId: 1,
            otherCurrencies: [],
            isGregorian: false,
            startDate: null,
            endDate: null,
            fiscalYearTitle: null,
        },
        others: [
            { fieldActivity: null },
            { economicalCode: null },
            { nationalID: null },
            { registrationNumber: null },
            { country: null },
            { state: null },
            { city: null },
            { postalCode: null },
            { address: null },
            { phone: null },
            { fax: null },
            { email: null },
            { webSite: null },
            { businessType: businessTypes[0].value },
            { startDate: null },
            { endDate: null },
            { warehouseAccountingSystem: warehouseAccountingSystem[0].value },
            { warehouseAnalyzeSystem: warehouseAnalyzeSystem[0].value },
            { 2222222: null },
            { taxRate: taxRateData },
            { calendar: "هجری شمسی" },
            { multipleCurrency: false },
            { warehouseSystem: 0 },
        ],
    });

    useEffect(() => {
        if (business) {
            navigate("/dashboard");
        } else {
            dispatch(apiGetCurrencies(token));
            dispatch(apiGetSubscriptions(token));
        }
    }, []);

    useEffect(() => {
        inputFields.main.startDate = formatDate(startDate);
        inputFields.others[14].startDate = formatDate(startDate);
    }, [startDate]);

    useEffect(() => {
        inputFields.main.endDate = formatDate(endDate);
        inputFields.others[15].endDate = formatDate(endDate);
    }, [endDate]);

    useEffect(() => {
        setInputFields((prev) => {
            prev.others[22].warehouseSystem = haveWarehouse ? "1" : "0";
            return prev;
        });
    }, [haveWarehouse]);

    useEffect(() => {
        setInputFields((prev) => {
            prev.others[21].multipleCurrency = multipleCurrency;
            return prev;
        });
    }, [multipleCurrency]);

    useEffect(() => {
        setInputFields((prev) => {
            prev.others[19].taxRate = taxRateData.toString();
            return prev;
        });
    }, [taxRateData]);

    useEffect(() => {
        paymentGateway["subscriptionId"] = subscriptionId;
    }, [subscriptionId]);

    const customSelectStyles = {
        control: (provided, state) => ({
            ...provided,
            minHeight: 30,
            height: 40,
            borderColor: "#c5c5c5",
            borderRadius: 8,
            marginTop: 2,
            marginBottom: 2,
            fontSize: 12,
        }),
        valueContainer: (provided, state) => ({
            ...provided,
            marginTop: -5,
        }),
        option: (provided, state) => ({
            ...provided,
            fontSize: 12,
        }),
    };

    const backToStep = () => {
        if (stepTwo) {
            setStepTwo(false);
            setStepOne(true);
        } else if (stepThree) {
            setStepThree(false);
            setStepOne(true);
        }
    };

    const tabSub = [
        { id: 1, title: "یک ماهه", duration: 1, percent: null },
        { id: 2, title: "شش ماهه", duration: 6, percent: "10%-" },
        { id: 3, title: "یکساله", duration: 12, percent: "20%-" },
    ];

    useEffect(() => {
        paymentGateway["duration"] = tabActiveValue.duration;
        paymentGateway["subscriptionId"] = subscriptions[0]?.id ?? 0;
    }, []);

    const [tabActiveValue, setTabActiveValue] = useState(tabSub[0]);
    const activeTabSub = (sub) => {
        setTabActiveValue(sub);
        paymentGateway["duration"] = sub.duration;
    };

    const displaySubscriptionPrice = (subscription) => {
        const subscriptionPrice = subscription.Subscription_Prices.find((sp) => {
            return sp.duration === tabActiveValue.duration;
        });
        return formatPrice(subscriptionPrice.price.toString() ?? "0");
    };

    const setValueCalender = (event) => {
        const value = event.target.value;
        setInputFields((prev) => {
            prev.main.isGregorian = event.target.value === "میلادی";
            prev.others[20].calendar = event.target.value;
            return prev;
        });
    };

    const funBuySub = () => {
        if (subscriptionId) {
            dispatch(apiSetSubscriptions(paymentGateway, token));
        } else {
            dispatch(apiSetAlert("لطفا طرح مورد نظر خود را انتخاب نمایید", "warning"));
        }
    };

    return (
        <div className="warp-add-account">
            <div className="box-add-account">
                <Container maxWidth="lg">
                    <div className="title-add-account">افزودن کسب و کار جدید</div>
                    <div className="title-tab-add-account">
                        <div className="tabs">
                            <div className={stepOne ? "tabs-active" : ""}>
                                <p className="number-tabs-account">۱.</p>اطلاعات کسب و کار جدید
                                <div className="border-active-add-account" />
                            </div>
                            <div className={stepTwo ? "tabs-active" : ""}>
                                <p className="number-tabs-account">۲.</p>اطلاعات حسابداری
                                <div className="border-active-add-account" />
                            </div>
                            <div className={stepThree ? "tabs-active" : ""}>
                                <p className="number-tabs-account">۳.</p>اشتراک
                                <div className="border-active-add-account" />
                            </div>
                        </div>
                        <div className="border-style-tabs" />
                    </div>
                    {stepOne ? (
                        <>
                            <div className="data-info-tabs">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12 cl-xs-12 title-info-users mb-3">
                                        اطلاعات شناسایی
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <NewInput
                                            placeholder=""
                                            value={inputFields.main.nickName}
                                            label={"نام کسب و کار *"}
                                            onChange={(e) =>
                                                setInputFields((prev) => {
                                                    if (prev.main.legalName === null || prev.main.legalName === prev.main.nickName) {
                                                        prev.main.legalName = e.target.value;
                                                    }
                                                    prev.main.nickName = e.target.value;
                                                    forceUpdate();
                                                    return prev;
                                                })
                                            }
                                        />
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <NewInput
                                            placeholder=""
                                            label={"نام قانونی *"}
                                            value={inputFields.main.legalName}
                                            onChange={(e) =>
                                                setInputFields((prev) => {
                                                    prev.main.legalName = e.target.value;
                                                    forceUpdate();
                                                    return prev;
                                                })
                                            }
                                        />
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <label className="label-wrap-new-input">نوع کسب و کار</label>
                                        <div>
                                            <Select
                                                styles={customSelectStyles}
                                                defaultValue={businessTypes[0]}
                                                isRtl={true}
                                                options={businessTypes}
                                                onChange={(value) => {
                                                    setInputFields((prev) => {
                                                        prev.others[13].businessType = value.value;
                                                        forceUpdate();
                                                        return prev;
                                                    });
                                                }}
                                                noOptionsMessage={({ inputValue }) =>
                                                    !inputValue ? "نتیجه ای پیدا نشد" : "نتیجه ای پیدا نشد"
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <NewInput
                                            placeholder="آرایشی بهداشتی"
                                            label={"زمینه فعالیت"}
                                            value={inputFields.others[0].fieldActivity}
                                            onChange={(e) =>
                                                setInputFields((prev) => {
                                                    prev.others[0].fieldActivity = e.target.value;
                                                    forceUpdate();
                                                    return prev;
                                                })
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="data-info-tabs">
                                <div className="row">
                                    <div
                                        className="col-lg-12 col-md-12 col-sm-12 cl-xs-12 title-info-users"
                                        onClick={() => setToggleEconomicInformation(!toggleEconomicInformation)}
                                    >
                                        اطلاعات اقتصادی
                                        <img src={arrowDropdown} alt="arrowDropdown" className="img-new-title" />
                                    </div>
                                    {toggleEconomicInformation ? (
                                        <>
                                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                                <NewInput
                                                    placeholder=""
                                                    label={"کد اقتصادی"}
                                                    value={inputFields.others[1].economicalCode}
                                                    onChange={(e) =>
                                                        setInputFields((prev) => {
                                                            prev.others[1].economicalCode = formatNumber(e.target.value);
                                                            forceUpdate();
                                                            return prev;
                                                        })
                                                    }
                                                />
                                            </div>
                                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                                <NewInput
                                                    placeholder=""
                                                    label={"شناسه ملی"}
                                                    value={inputFields.others[2].nationalID}
                                                    onChange={(e) =>
                                                        setInputFields((prev) => {
                                                            prev.others[2].nationalID = formatNumber(e.target.value);
                                                            forceUpdate();
                                                            return prev;
                                                        })
                                                    }
                                                />
                                            </div>
                                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                                <NewInput
                                                    placeholder=""
                                                    label={"شماره ثبت"}
                                                    value={inputFields.others[3].registrationNumber}
                                                    onChange={(e) =>
                                                        setInputFields((prev) => {
                                                            prev.others[3].registrationNumber = formatNumber(e.target.value);
                                                            forceUpdate();
                                                            return prev;
                                                        })
                                                    }
                                                />
                                            </div>
                                            {/* <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                      <label className="labels-new">تاریخ شروع فعالیت</label>
                      <div className="warp-date-picker">
                        {toggleDatePicker == true ? (
                          <div className="warp-calender">
                            <Calendar
                              value={value}
                              isGregorian={false}
                              onChange={(value) => {
                                setValue(value);
                                setToggleDatePicker(false);
                              }}
                            />
                          </div>
                        ) : (
                          ""
                        )}
                        <div
                          className="show-calender"
                          onClick={() => switchValueDatePicker()}
                        >
                          <div className="title-date-picker">تاریخ</div>
                          <div>{formatDate(value)}</div>
                          <img
                            className="img-icon-date-picker"
                            src={imgDatePicker}
                            alt={imgDatePicker}
                          />
                        </div>
                      </div>
                    </div> */}
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                </div>
                            </div>
                            <div className="data-info-tabs">
                                <div className="row">
                                    <div
                                        className="col-lg-12 col-md-12 col-sm-12 cl-xs-12 title-info-users"
                                        onClick={() => setContacts(!contacts)}
                                    >
                                        اطلاعات تماس
                                        <img src={arrowDropdown} alt="arrowDropdown" className="img-new-title" />
                                    </div>
                                    {contacts ? (
                                        <>
                                            {/*<div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">*/}
                                            {/*    <NewInput*/}
                                            {/*        placeholder=""*/}
                                            {/*        label={"کشور"}*/}
                                            {/*        value={inputFields.others[4].country}*/}
                                            {/*        onChange={(e) =>*/}
                                            {/*            setInputFields((prev) => {*/}
                                            {/*                prev.others[4].country = e.target.value;*/}
                                            {/*                forceUpdate();*/}
                                            {/*                return prev;*/}
                                            {/*            })*/}
                                            {/*        }*/}
                                            {/*    />*/}
                                            {/*</div>*/}
                                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                                <label className="label-wrap-new-input">استان</label>
                                                <div>
                                                    <Select
                                                        styles={customSelectStyles}
                                                        defaultValue={States.find((c) => c.label === "تهران")}
                                                        isRtl={true}
                                                        options={States}
                                                        onChange={(value) => {
                                                            setState(value);
                                                            setCity(Cities.filter((c) => c.stateId === value.id)[0]);
                                                            setInputFields((prev) => {
                                                                prev.others[5].state = value.value;
                                                                forceUpdate();
                                                                return prev;
                                                            });
                                                        }}
                                                        noOptionsMessage={({ inputValue }) =>
                                                            !inputValue ? "نتیجه ای پیدا نشد" : "نتیجه ای پیدا نشد"
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                                <label className="label-wrap-new-input">شهر</label>
                                                <div>
                                                    <Select
                                                        styles={customSelectStyles}
                                                        defaultValue={Cities.find((c) => c.label === "تهران")}
                                                        isRtl={true}
                                                        options={Cities.filter((c) => c.stateId === state.id)}
                                                        value={city}
                                                        onChange={(value) => {
                                                            setCity(value);
                                                            setInputFields((prev) => {
                                                                prev.others[6].city = value.value;
                                                                forceUpdate();
                                                                return prev;
                                                            });
                                                        }}
                                                        noOptionsMessage={({ inputValue }) =>
                                                            !inputValue ? "نتیجه ای پیدا نشد" : "نتیجه ای پیدا نشد"
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                                <NewInput
                                                    placeholder="0211234567890"
                                                    label={"تلفن"}
                                                    value={inputFields.others[9].phone}
                                                    maxLength={15}
                                                    onChange={(e) =>
                                                        setInputFields((prev) => {
                                                            prev.others[9].phone = e.target.value;
                                                            forceUpdate();
                                                            return prev;
                                                        })
                                                    }
                                                />
                                            </div>
                                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                                <NewInput
                                                    placeholder="1234567890"
                                                    label={"کدپستی"}
                                                    value={inputFields.others[7].postalCode}
                                                    maxLength={10}
                                                    onChange={(e) =>
                                                        setInputFields((prev) => {
                                                            prev.others[7].postalCode = formatNumber(e.target.value);
                                                            forceUpdate();
                                                            return prev;
                                                        })
                                                    }
                                                />
                                            </div>
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <NewInput
                                                    placeholder=""
                                                    label={"آدرس"}
                                                    value={inputFields.others[8].address}
                                                    onChange={(e) =>
                                                        setInputFields((prev) => {
                                                            prev.others[8].address = e.target.value;
                                                            forceUpdate();
                                                            return prev;
                                                        })
                                                    }
                                                />
                                            </div>
                                            {/*<div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">*/}
                                            {/*    <NewInput*/}
                                            {/*        placeholder="0211234567890"*/}
                                            {/*        label={"فکس"}*/}
                                            {/*        value={inputFields.others[10].fax}*/}
                                            {/*        maxLength={15}*/}
                                            {/*        onChange={(e) =>*/}
                                            {/*            setInputFields((prev) => {*/}
                                            {/*                prev.others[10].fax = formatNumber(e.target.value);*/}
                                            {/*                forceUpdate();*/}
                                            {/*                return prev;*/}
                                            {/*            })*/}
                                            {/*        }*/}
                                            {/*    />*/}
                                            {/*</div>*/}
                                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                                <NewInput
                                                    placeholder="me@business.ir"
                                                    label={"ایمیل"}
                                                    value={inputFields.others[11].email}
                                                    onChange={(e) =>
                                                        setInputFields((prev) => {
                                                            prev.others[11].email = e.target.value;
                                                            forceUpdate();
                                                            return prev;
                                                        })
                                                    }
                                                />
                                            </div>
                                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                                <NewInput
                                                    placeholder="https://mybusiness.ir"
                                                    label={"وب سایت"}
                                                    value={inputFields.others[12].webSite}
                                                    onChange={(e) =>
                                                        setInputFields((prev) => {
                                                            prev.others[12].webSite = e.target.value;
                                                            forceUpdate();
                                                            return prev;
                                                        })
                                                    }
                                                />
                                            </div>
                                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6"></div>
                                        </>
                                    ) : null}
                                </div>
                            </div>
                        </>
                    ) : (
                        ""
                    )}
                    {stepTwo == true ? (
                        <div className="data-info-tabs">
                            <div className="row">
                                <div className="col-lg-12 col-md-12 col-sm-12 cl-xs-12 title-info-users mb-4">
                                    امکانات حسابداری
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3">
                                    <CheckBox
                                        label={"سیستم انبارداری"}
                                        changeValue={(value) => {
                                            setHaveWarehouse(value);
                                        }}
                                    />
                                </div>
                                {haveWarehouse ? (
                                    <>
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 mt-2">
                                            <label className="label-wrap-new-input">سیستم حسابداری انبار</label>
                                            <div className={"w-100"}>
                                                <Select
                                                    styles={customSelectStyles}
                                                    isRtl={true}
                                                    defaultValue={warehouseAccountingSystem[0]}
                                                    options={warehouseAccountingSystem}
                                                    onChange={(value) => {
                                                        setInputFields((prev) => {
                                                            prev.others[16].warehouseAccountingSystem = value.value;
                                                            forceUpdate();
                                                            return prev;
                                                        });
                                                    }}
                                                    noOptionsMessage={({ inputValue }) =>
                                                        !inputValue ? "نتیجه ای پیدا نشد" : "نتیجه ای پیدا نشد"
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 mt-2">
                                            <label className="label-wrap-new-input">روش ارزش یابی انبار</label>
                                            <div className={"w-100"}>
                                                <Select
                                                    styles={customSelectStyles}
                                                    isRtl={true}
                                                    defaultValue={warehouseAnalyzeSystem[0]}
                                                    options={warehouseAnalyzeSystem}
                                                    onChange={(value) => {
                                                        setInputFields((prev) => {
                                                            prev.others[17].warehouseAnalyzeSystem = value.value;
                                                            forceUpdate();
                                                            return prev;
                                                        });
                                                    }}
                                                    noOptionsMessage={({ inputValue }) =>
                                                        !inputValue ? "نتیجه ای پیدا نشد" : "نتیجه ای پیدا نشد"
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <></>
                                )}
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-5">
                                    <CheckBox
                                        label={"سیستم چند ارزی"}
                                        changeValue={(value) => {
                                            setMultipleCurrency(value);
                                        }}
                                    />
                                </div>
                                {multipleCurrency ? (
                                    <>
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 mt-2">
                                            <label className="label-wrap-new-input">واحد پول اصلی</label>
                                            <div className={"w-100"}>
                                                <Select
                                                    styles={customSelectStyles}
                                                    isRtl={true}
                                                    defaultValue={currencies[0]}
                                                    options={currencies}
                                                    onChange={(value) => {
                                                        setInputFields((prev) => {
                                                            prev.main.currencyId = value.id;
                                                            forceUpdate();
                                                            return prev;
                                                        });
                                                    }}
                                                    noOptionsMessage={({ inputValue }) =>
                                                        !inputValue ? "نتیجه ای پیدا نشد" : "نتیجه ای پیدا نشد"
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 mt-2">
                                            <label className="label-wrap-new-input">سایر ارزها</label>
                                            <div className={"w-100"}>
                                                <Select
                                                    styles={customSelectStyles}
                                                    placeholder={"سایر ارزها"}
                                                    isRtl={true}
                                                    isMulti={true}
                                                    options={currencies.filter((c) => {
                                                        return c.id !== inputFields.main.currencyId;
                                                    })}
                                                    onChange={(value) => {
                                                        setInputFields((prev) => {
                                                            prev.main.otherCurrencies = value;
                                                            return prev;
                                                        });
                                                    }}
                                                    noOptionsMessage={({ inputValue }) =>
                                                        !inputValue ? "نتیجه ای پیدا نشد" : "نتیجه ای پیدا نشد"
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <></>
                                )}
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-5">
                                    <label className="title-info-users">مالیات بر ارزش افزوده</label>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 mt-4">
                                    <div className="btn-plus-mini-add-account">
                                        <img src={IconPlus} alt="IconPlus" onClick={() => plusFunc()} />
                                        <span>{taxRateData}%</span>
                                        <img
                                            src={IconMini}
                                            alt="IconMini"
                                            onClick={() => minusFunc()}
                                            className="img-icon-mini"
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-5">
                                    <label className="title-info-users">نوع تقویم کسب و کار</label>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 mt-4">
                                    <div className="d-flex justify-content-around">
                                        <div>
                                            <input
                                                type="radio"
                                                value="هجری شمسی"
                                                id="calendar-jalali"
                                                onChange={setValueCalender}
                                                name="calendar"
                                            />
                                            <label htmlFor="calendar-jalali">&nbsp;هجری شمسی</label>
                                        </div>
                                        <div>
                                            <input
                                                type="radio"
                                                value="میلادی"
                                                id="calendar-gregorian"
                                                onChange={setValueCalender}
                                                name="calendar"
                                            />
                                            <label htmlFor="calendar-gregorian">&nbsp;میلادی</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-5">
                                    <label className="title-info-users">اطلاعات سال مالی</label>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 mt-3">
                                    <NewInput
                                        placeholder={"سال مالی 1401"}
                                        label={"عنوان سال مالی *"}
                                        value={inputFields.main.fiscalYearTitle}
                                        onChange={(e) =>
                                            setInputFields((prev) => {
                                                prev.main.fiscalYearTitle = e.target.value;
                                                prev.others[18].fiscalYearTitle = e.target.value;
                                                forceUpdate();
                                                return prev;
                                            })
                                        }
                                    />
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 mt-3">
                                    <label className="labels-new">تاریخ شروع *</label>
                                    <div className="warp-date-picker">
                                        {toggleDatePicker && toggleDatePicker === "startDate" ? (
                                            <div className="warp-calender">
                                                <Calendar
                                                    startDate={startDate}
                                                    isGregorian={false}
                                                    onChange={(startDate) => {
                                                        setStartDate(startDate);
                                                        setToggleDatePicker(false);
                                                    }}
                                                />
                                            </div>
                                        ) : (
                                            ""
                                        )}
                                        <div className="show-calender"
                                            onClick={() => switchValueDatePicker("startDate")}>
                                            <div className="title-date-picker">تاریخ</div>
                                            <div>{formatDate(startDate)}</div>
                                            <img className="img-icon-date-picker" src={imgDatePicker}
                                                alt={imgDatePicker} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 mt-3">
                                    <label className="labels-new">تاریخ پایان *</label>
                                    <div className="warp-date-picker">
                                        {toggleDatePicker && toggleDatePicker === "endDate" ? (
                                            <div className="warp-calender">
                                                <Calendar
                                                    endDate={endDate}
                                                    isGregorian={false}
                                                    onChange={(endDate) => {
                                                        setEndDate(endDate);
                                                        setToggleDatePicker(false);
                                                        setInputFields((prev) => {
                                                            prev.main.fiscalYearTitle = `سال مالی منتهی به ${formatDate(endDate)}`;
                                                            forceUpdate();
                                                            return prev;
                                                        });
                                                    }}
                                                />
                                            </div>
                                        ) : (
                                            ""
                                        )}
                                        <div className="show-calender" onClick={() => switchValueDatePicker("endDate")}>
                                            <div className="title-date-picker">تاریخ</div>
                                            <div>{formatDate(endDate)}</div>
                                            <img className="img-icon-date-picker" src={imgDatePicker}
                                                alt={imgDatePicker} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        ""
                    )}
                    {stepThree ? (
                        <div className="data-info-tabs">
                            <div className="row">
                                <div className="col-glg-12 col-md-12 col-sm-12 col-xs-12 wrap-header-sterp-three">
                                    <div className="header-step-three-bussiness">
                                        <img src={cartBussines} alt="cartBussines" />
                                        <div>
                                            خرید اشتراک برای : <b>{inputFields.main.nickName}</b>
                                            <span>({inputFields.main.legalName})</span>
                                        </div>
                                    </div>
                                    {/* <div
                  className="edit-info-step-three"
                  onClick={() => backToStep()}
                >
                  ویرایش اطلاعات
                </div> */}
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12 cl-xs-12 title-info-users mb-4">
                                    <div className="warp-tep-three">
                                        <span>1</span> روز آزمایشی
                                    </div>
                                    <div className="description-step-three">
                                        از امکانات چرتکه استفاده کنید و سپس اشتراک بخرید
                                    </div>
                                    <div className="wrap-tab-subscription">
                                        <div className="box-tab-subscription">
                                            {tabSub.map((sub, index) => {
                                                return (
                                                    <div key={index}
                                                        className={tabActiveValue.id === sub.id ? "active-item-tab-sub" : "item-tab-sub"}
                                                        onClick={() => activeTabSub(sub)}
                                                    >
                                                        {sub.title} {sub.percent ? <span>{sub.percent}</span> : null}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                    {subscriptions.map((sub, index) => {
                                        return (
                                            <div key={index} className="warp-items-step-three"
                                                onClick={() => setSubscriptionId(sub.id)}>
                                                <div className="items-step-three">
                                                    <div
                                                        className="item row"
                                                        style={
                                                            sub.special != null
                                                                ? {
                                                                    width: "100%",
                                                                    height: "150px",
                                                                    paddingTop: "30px",
                                                                }
                                                                : {}
                                                        }
                                                    >
                                                        {sub.special != null ? (
                                                            <div className="special-icon-star">
                                                                <img src={IconStar} alt="IconStar" />
                                                                {sub.special}
                                                            </div>
                                                        ) : (
                                                            ""
                                                        )}
                                                        <input
                                                            className="radio-item-account form-check-input"
                                                            type="radio"
                                                            value={sub.id}
                                                            name="subscriptionId"
                                                            checked={subscriptionId === sub.id}
                                                        />
                                                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6">
                                                            <div className="title-item">
                                                                <img src={sub.icon} alt="IconBasicSubscription" />
                                                                <b>اشتراک {sub.title}</b>
                                                            </div>
                                                            <p className="desc-item">{sub.description}</p>
                                                        </div>
                                                        <div
                                                            className="col-lg-4 col-md-4 col-sm-4 col-xs-6 part-two-add-aacount">
                                                            {sub.Subscription_Features.map((sf, index) => {
                                                                return (
                                                                    <div key={index}>
                                                                        <img src={TickIcon} alt="TickIcon" />
                                                                        {sf.title}
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                        <div
                                                            className="col-lg-4 col-md-4 col-sm-4 col-xs-6 part-three-add-aacount">
                                                            <div
                                                                className="div-total">{displaySubscriptionPrice(sub)} تومان
                                                            </div>
                                                            <div
                                                                className="div-support">{/* پشتیبانی : {sub.support} / سال */}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    ) : null}

                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6"></div>
                        {stepThree !== true ? (
                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                <div className="btn-next-page-add-account">
                                    {stepOne ? (
                                        <button className="btn-cancel-add-account" onClick={() => navigate("/")}>
                                            انصراف
                                        </button>
                                    ) : (
                                        <button className="btn-cancel-add-account" onClick={() => backToStep()}>
                                            بازگشت
                                        </button>
                                    )}
                                    <button
                                        disabled={sendingRequest}
                                        className="step-btn-add-account"
                                        onClick={() => stepFund()}
                                    >
                                        {sendingRequest ? (
                                            <img src={iconLoading} alt="loading" />
                                        ) : (
                                            <>
                                                مرحله بعد
                                                <img src={arrowAddAccount} alt="arrowAddAccount" />
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                <div className="btn-next-page-add-account">
                                    <button className="btn-cancel-add-account-new" onClick={() => navigate("/")}>
                                        <img src={DemoIconAuth} alt="DemoIconAuth" />
                                        شروع 1 روز آزمایشی
                                    </button>
                                    <button
                                        disabled={sendingRequest}
                                        className="step-btn-add-account"
                                        onClick={() => funBuySub()}
                                    >
                                        {sendingRequest ? (
                                            <img src={iconLoading} alt="loading" />
                                        ) : (
                                            <>
                                                خرید اشتراک
                                                <img src={BuyBasket} alt="BuyBasket" />
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </Container>
            </div>
        </div>
    );

    function stepFund() {
        let messages = [];
        if (!inputFields.main.nickName) {
            messages.push("نام کسب و کار حتما باید وارد شود");
        }
        if (!inputFields.main.legalName) {
            messages.push("نام قانونی حتما باید وارد شود");
        }

        if (messages.length > 0) {
            dispatch(apiSetAlert(messages, "error"));
        } else {
            if (stepOne) {
                setStepTwo(true);
                setStepOne(false);
            } else if (stepTwo) {
                const others = [];
                inputFields.others.map((f) => {
                    Object.keys(f).map((key) => {
                        if (f[key] === "") {
                            f[key] = null;
                        }
                    });
                    others.push(f);
                });
                inputFields.others = others;

                dispatch(appSetSendingRequest(true));
                axios
                    .post("/businesses", inputFields, {
                        headers: { Authorization: `Bearer ${token}` },
                    })
                    .then((response) => {
                        paymentGateway["businessId"] = response.data.business.id;
                        dispatch(apiSetAlert(response.data.message, "success", false));
                        // navigate('/')
                        // dispatch(apiGetBusiness(response.data.business, token));
                        navigate("/", {
                            state: {
                                extendBusinessId: response.data.business.id,
                            },
                        });
                        // setStepTwo(false);
                        // setStepOne(false);
                        // setStepThree(true);
                    })
                    .catch((error) => {
                        errorDispatcher(error, dispatch);
                    });
            }
        }
    }

    function plusFunc() {
        if (taxRateData < 99) {
            setTaxRateData(taxRateData + 1);
        }
    }

    function minusFunc() {
        if (taxRateData > 0) {
            setTaxRateData(taxRateData - 1);
        }
    }

    function buySubscription() {
        dispatch(appReset());
        dispatch(apiAddBusinesses(inputFields, token, navigate));
    }

    function switchValueDatePicker(value) {
        setToggleDatePicker(value);
    }
}